import script from "./InputImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputImage.vue?vue&type=script&setup=true&lang=ts"

import "./InputImage.vue?vue&type=style&index=0&id=322c0d0e&scoped=true&lang=css"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322c0d0e"]])

export default __exports__